import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "./react-auth0-spa";
import history from "./utils/history";

// A function that routes the user to the right place
// after login
const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

if (process != null && process.env != null && process.env.REACT_APP_IS_LOCAL === 'true') {
  window.REACT_APP_SERVICE_URL=process.env.REACT_APP_SERVICE_URL;
  window.REACT_APP_AUTH0_DOMAIN=process.env.REACT_APP_AUTH0_DOMAIN;
  window.REACT_APP_AUTH0_CLIENT_ID=process.env.REACT_APP_AUTH0_CLIENT_ID;
  window.REACT_APP_AUTH0_AUDIENCE=process.env.REACT_APP_AUTH0_AUDIENCE;
}

ReactDOM.render(
  <Auth0Provider
    domain={window.REACT_APP_AUTH0_DOMAIN}
    client_id={window.REACT_APP_AUTH0_CLIENT_ID}
    redirect_uri={window.location.origin}
    audience={window.REACT_APP_AUTH0_AUDIENCE}
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();